module.exports = __webpack_public_path__ + "static/img/event7.21cf88d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/event7.png
// module id = uMlX
// module chunks = 1